export default __webpack_public_path__ + "static/media/mergedPatient.738c9a98.png";